//model-meta generated file
import {DateTime,ModelMeta,uuid} from '../../lib/model-meta';
import {WhereTable,RestTypes as _RestTypes} from '../../lib/model-meta';

export class Site{
	public id:number;
	public name:string;
	public token:string|null=null;
	public clientId:number;
	public enabled:boolean=true;
}

export namespace Site{
	export const meta=new ModelMeta<keyof Props>(
		"Site",
		[],
		[
			{
				name: "id",
				type: "serial",
				decorators: {},
				uniqueKey: true,
				notNull: true
			},{
				name: "name",
				type: "string",
				decorators: {
					uniqueKey: true
				},
				uniqueKey: true,
				notNull: true
			},{
				name: "token",
				type: "string",
				decorators: {
					uniqueKey: true
				},
				uniqueKey: true,
				default: null,
				optional: true
			},{
				name: "clientId",
				type: "int",
				decorators: {},
				notNull: true
			},{
				name: "enabled",
				type: "boolean",
				decorators: {},
				default: true,
				optional: true,
				notNull: true
			}
		]
	);

	interface Props{
		id:number;
		name:string;
		token?:string|null;
		clientId:number;
		enabled?:boolean;
	}


	meta.generateRest("sites",[
		{
			name: "email",
			type: "string",
			decorators: {}
		},{
			name: "authToken",
			type: "string",
			decorators: {}
		}
	]);

	export interface ReadableProps{
		id:number;
		name:string;
		token?:string|null;
		clientId:number;
		enabled?:boolean;
	}

	export interface ReadablePrimitiveProps{
		id:number;
		name:string;
		token?:string|null;
		clientId:number;
		enabled?:boolean;
	}

	namespace body{

		interface WritableProps{
			name:string;
			token?:string|null;
			clientId:number;
			enabled?:boolean;
		}

		export interface Auth{
			email?:string;
			authToken?:string;
		}

		export interface Get extends Auth{
			where:number;
			fields?:(keyof ReadableProps)[];
		}

		export interface Put extends Auth{
			where:number;
			fields:Partial<WritableProps>;
		}

		export interface Post extends Auth{
			fields:Partial<WritableProps>;
		}

		export interface Delete extends Auth{
			where:number;
		}

		export interface Count extends Auth{
			where?:WhereTable<keyof ReadablePrimitiveProps>;
		}

		export interface Search extends Auth{
			fields?:(keyof ReadablePrimitiveProps)[];
			where?:WhereTable<keyof ReadablePrimitiveProps>;
			range?:[number,number];
			sort?:Partial<Record<keyof ReadablePrimitiveProps,'+'|'-'>>;
		}
	}

	namespace _response{
		export type Get=Partial<ReadableProps>;
		export type Search=Partial<ReadablePrimitiveProps>[];
	}

	export interface RestTypes extends _RestTypes{
		body:{
			Auth:body.Auth;
			Get:body.Get;
			Put:body.Put;
			Post:body.Post;
			Delete:body.Delete;
			Count:body.Count;
			Search:body.Search;
		}

		response: {
			Get:_response.Get;
			Search:_response.Search;
		}
	}

}
